import { QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { NewSmartList, SmartList } from 'shared/types/smart-list';

import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const smartListConverter = {
  toFirestore(smartList: SmartList) {
    return smartList;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
  ): SmartList {
    return firebaseObjectTimestampToDate(snapshot.data(options)) as SmartList;
  },
};

export const newSmartListConverter = (smartList: NewSmartList) => ({
  ...smartList,
  createdAt: new Date(),
});
